import { Redirect, Route, Switch } from 'quartz-routing/react-router';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentLoading from './components/AsyncComponentLoading';
// @ts-ignore file not converted to TS yet
import { LegacyRoutes } from './legacyRoutes';
import { useMobileReauthCookie } from './hooks/useMobileReauthCookie';
import { MobileLoginContext } from './context/MobileLoginContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Login = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-LoginV4" */'./components/Login'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const PasswordResetPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-passwordReset" */'./components/PasswordReset/PasswordResetPage').then(m => m.default),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const RequestResetEmailPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-requestResetEmail" */'./components/RequestResetEmail/RequestResetEmailPage').then(m => m.default),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorAuthPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactorAuthPage" */'./components/TwoFactorAuth/TwoFactorAuthPage'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRemovalNametag = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactorRemovalNametag" */'./components/TwoFactorRequestRecovery/TwoFactorRemovalNametag'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRequestRecoveryAdmin = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactorRequestRecoveryAdmin" */'./components/TwoFactorRequestRecovery/TwoFactorRequestRecoveryAdmin'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const PasskeyRecoveryVerifyPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-PasskeyRecoveryVerifyPage" */'./components/PasskeyRecoveryVerify/PasskeyRecoveryVerifyPage'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorPasskeyRemoval = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-PasskeyRequestRecovery" */'./components/TwoFactorRequestRecovery/PasskeyRemoval'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const UnifiedAdminRecovery = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-UnifiedAdminRecovery" */'./components/TwoFactorRequestRecovery/UnifiedAdminRecovery'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const RecoveryOptions = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-RecoveryOptions" */'./components/TwoFactorRequestRecovery/RecoveryOptions'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const ContactSupportRecovery = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-ContactSupportRecovery" */'./components/TwoFactorRequestRecovery/ContactSupportRecovery'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const OtpPollingInitPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-OtpPollingInitPage" */'./components/OtpPollingInit/OtpPollingInitPage').then(m => m.default),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const PasskeyPollingCompletePage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-PasskeyPollingCompletePage" */'./components/PasskeyPollingComplete/PasskeyPollingCompletePage').then(m => m.default),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const PasskeyPollingInitPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-PasskeyPollingInitPage" */'./components/PasskeyPollingInit/PasskeyPollingInitPage').then(m => m.default),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const LoginLinkInfoPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-LoginLinkInfoPage" */'./components/ConfirmToLogin/LoginLinkInfoPage'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const ConfirmToLoginPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-ConfirmToLoginPage" */'./components/ConfirmToLogin/ConfirmToLoginPage'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const VettingPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-VettingPage" */'./components/VettingPage').then(m => m.default),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TrustedTokenPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TrustedTokenPage" */'./components/TrustedTokenPage/TrustedTokenPage').then(m => m.default),
  ErrorComponent: AsyncComponentLoading
});
const SsoIdpPickerPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-SsoIdpPickerPage" */'./components/SsoLogin/SsoIdpPickerPage').then(m => m.default),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const OtpLoginPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-OtpLoginPage" */'./components/OtpLogin/OtpLoginPage').then(m => m.default),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
export const LoginRoutes = () => {
  const isMobileLogin = useMobileReauthCookie();
  return /*#__PURE__*/_jsx(MobileLoginContext.Provider, {
    value: isMobileLogin,
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: Login,
        exact: true,
        path: ['/', '/chatspot', '/connect']
      }, "login-route"), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/two-factor",
        render: routeProps => /*#__PURE__*/_jsx(TwoFactorAuthPage, Object.assign({}, routeProps, {
          route: {
            name: 'twoFactorAuth'
          }
        }))
      }, "v4-two-factor-route"), /*#__PURE__*/_jsx(Route, {
        path: "/beta",
        exact: true,
        children: /*#__PURE__*/_jsx(Redirect, {
          to: "/"
        })
      }), /*#__PURE__*/_jsx(Route, {
        component: RequestResetEmailPage,
        exact: true,
        path: ['/forgot', '/password-leak', '/suspicious-activity', '/anomalous-login', '/idle-user', '/update-password']
      }, "forgot-route"), /*#__PURE__*/_jsx(Route, {
        component: PasswordResetPage,
        exact: true,
        path: "/passwordReset"
      }, "password-reset-route"), /*#__PURE__*/_jsx(Route, {
        component: ConfirmToLoginPage,
        exact: true,
        path: "/confirm-to-login"
      }, "confirm-to-login-page-route"), /*#__PURE__*/_jsx(Route, {
        component: LoginLinkInfoPage,
        exact: true,
        path: "/confirm-to-login/login-link"
      }, "login-link-info-page-route"), /*#__PURE__*/_jsx(Route, {
        component: TwoFactorRequestRecoveryAdmin,
        exact: true,
        path: "/two-factor/recovery"
      }, "two-factor-request-recovery-admin-route"), /*#__PURE__*/_jsx(Route, {
        component: TwoFactorPasskeyRemoval,
        exact: true,
        path: "/two-factor/passkey-removal"
      }, "two-factor-passkey-request-removal-route"), /*#__PURE__*/_jsx(Route, {
        component: PasskeyRecoveryVerifyPage,
        exact: true,
        path: "/passkey/recovery-verify"
      }, "passkey-recovery-verify-route"), /*#__PURE__*/_jsx(Route, {
        component: PasskeyPollingCompletePage,
        exact: true,
        path: "/passkey-polling-complete"
      }, "passkey-polling-complete-route"), /*#__PURE__*/_jsx(Route, {
        component: PasskeyPollingInitPage,
        exact: true,
        path: "/passkey-polling-init"
      }, "passkey-polling-init-route"), /*#__PURE__*/_jsx(Route, {
        component: OtpPollingInitPage,
        exact: true,
        path: "/otp-polling-init"
      }, "otp-polling-init-route"), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/legacy",
        children: /*#__PURE__*/_jsx(Redirect, {
          to: "/"
        })
      }, "legacy-login-route-redirect"), /*#__PURE__*/_jsx(Route, {
        component: TwoFactorRemovalNametag,
        exact: true,
        path: "/two-factor/support-recovery"
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/two-factor/unified-recovery",
        render: props => /*#__PURE__*/_jsx(TwoFactorRemovalNametag, Object.assign({}, props, {
          isUnified: true
        }))
      }), /*#__PURE__*/_jsx(Route, {
        component: UnifiedAdminRecovery,
        exact: true,
        path: "/two-factor/unified-admin-recovery"
      }), /*#__PURE__*/_jsx(Route, {
        component: RecoveryOptions,
        exact: true,
        path: "/two-factor/recovery-options"
      }), /*#__PURE__*/_jsx(Route, {
        component: ContactSupportRecovery,
        exact: true,
        path: "/two-factor/contact-support"
      }), /*#__PURE__*/_jsx(Route, {
        path: "/vetting",
        render: props => /*#__PURE__*/_jsx(VettingPage, Object.assign({}, props, {
          route: {
            name: 'vetting'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/trust-token",
        exact: true,
        component: TrustedTokenPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/sso-idp-picker",
        exact: true,
        component: SsoIdpPickerPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/otp-login",
        exact: true,
        component: OtpLoginPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "*",
        render: ({
          location
        }) => /*#__PURE__*/_jsx(LegacyRoutes, {
          location: location,
          isMobileLogin: isMobileLogin
        })
      })]
    })
  });
};